// v16 (2026-07) — Zalo link parser utility.
//
// User có thể nhập vào trường "Zalo" nhiều dạng:
//   • SĐT VN: "0901234567", "84901234567", "+84 901 234 567"
//   • Link zalo cá nhân: "https://zalo.me/84901234567"
//   • Link zalo nhóm: "https://zalo.me/g/rouzxg527"
//   • Zalo OA: "https://zalo.me/9999" (page id)
//
// Regex SĐT VN: `0` hoặc `84`/`+84` prefix + 9 chữ số (mobile only).
// (Số cố định 10-11 số không dùng cho Zalo → bỏ qua).

const VN_PHONE_REGEX = /(?:\+?84|0)(?:3|5|7|8|9)\d{8}\b/;
const ZALO_URL_REGEX = /^https?:\/\/(?:www\.)?zalo\.me\/[^\s]+/i;

/**
 * Parse zalo contact string thành `{ href, label, kind }` object.
 * Trả null nếu không detect được.
 */
export function parseZaloContact(raw) {
  if (!raw || typeof raw !== "string") return null;
  const s = raw.trim();
  if (!s) return null;
  // 1. Nếu đã là URL zalo.me → dùng nguyên.
  const urlMatch = s.match(ZALO_URL_REGEX);
  if (urlMatch) {
    return {
      href: urlMatch[0],
      label: s.startsWith(urlMatch[0]) && s.length > urlMatch[0].length + 2 ? s : "Chat Zalo",
      kind: s.includes("/g/") ? "group" : "personal",
    };
  }
  // 2. Detect SĐT VN, convert → zalo.me/84XXX
  const compact = s.replace(/[\s()\-.]/g, "");
  const phoneMatch = compact.match(VN_PHONE_REGEX);
  if (phoneMatch) {
    const raw84 = phoneMatch[0].replace(/^\+?84/, "").replace(/^0/, "");
    return {
      href: `https://zalo.me/84${raw84}`,
      label: `Zalo: 0${raw84}`,
      kind: "phone",
    };
  }
  return null;
}

/**
 * Detect SĐT trong string mixed (contact field BTC), return zalo info hoặc null.
 * Ví dụ: "0901234567 / test@a.com / facebook.com/x" → detect 0901234567.
 */
export function detectPhoneAsZalo(raw) {
  return parseZaloContact(raw);
}
